import {
    LIST_DRAW_RESULT_KH,
    FETCH_DRAW_RESULT_KH,
    MODIFY_DRAW_RESULT_KH,
    CLEAR_DRAW_RESULT_KH,
} from "./types";

const init = {
    isLoading: false,
    filter: {},
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_DRAW_RESULT_KH:
            return {
                ...state,
                filter: payload,
                isLoading: false
            };
        case LIST_DRAW_RESULT_KH:
            return {
                ...state,
                isLoading: false,
               ...payload

            };
        case MODIFY_DRAW_RESULT_KH:
            return {
                ...state,
                isLoading: true

            };
        case CLEAR_DRAW_RESULT_KH:
            return {
                ...init
            };

        default:
            return state;
    }
}